import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';


@Injectable({
  providedIn: 'root'
})
export class PtyDbService {

  private USER_TOKEN: string = 'pty_user_token';
  private USER_DATA: string = 'pty_user_data';
  private DEVICE_INFO: string = 'pty_device_info';

  constructor(private db: Storage) { }

  setData(key: string, value: any) {
    return this.db.set(key, value);
  }

  getData(key: string) {
    return this.db.get(key);
  }

  getUserToken() {
    return this.db.get(this.USER_TOKEN);
  }

  setUserToken(token: string) {
    return this.db.set(this.USER_TOKEN, token);
  }

  removeUserToken() {
    return this.db.remove(this.USER_TOKEN);
  }

  getUserData() {
    return this.db.get(this.USER_DATA);
  }

  setUserData(data: any) {
    let storage = this.db.set(this.USER_DATA, data);
    console.log("values of storage", storage)
    return storage;
  }

  removeUserData() {
    return this.db.remove(this.USER_DATA);
  }

  getPushDeviceInfo() {
    return this.db.get(this.DEVICE_INFO);
  }

  setPushDeviceInfo(deviceId: string) {
    return this.db.set(this.DEVICE_INFO, deviceId);
  }

  removePushDeviceInfo() {
    return this.db.remove(this.DEVICE_INFO);
  }
}
